import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { RadioButton } from "primereact/radiobutton";
import { NUMBER_LINE_RANGE_OPTIONS, NumberLineQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The two number line dials (ADR 0033 §2).
 *
 * The range has no effect on a fractions line, which always runs 0 to 1 - the
 * control stays visible rather than appearing and disappearing with the
 * question type, because a setting that vanishes is harder to find again than
 * one that is briefly inert.
 */
export function NumberLineSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleQuestionChange(value: NumberLineQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...settings, NumberLineQuestion: value });
    }

    function handleRangeChange(event) {
        setSettings({ ...settings, NumberLineRange: Number(event.target.value) });
    }

    return (
        <div className="numberLineSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.NumberLineQuestion}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(NumberLineQuestionOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.numberLineTypeAria')}
                />
            </div>
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.largestNumberLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.largestNumberAria')}>
                {NUMBER_LINE_RANGE_OPTIONS.map((option) => (
                    <div key={option}>
                        <RadioButton
                            inputId={`numberLineRange-${option}`}
                            value={option}
                            checked={settings.NumberLineRange === option}
                            onChange={handleRangeChange}
                        />
                        <label htmlFor={`numberLineRange-${option}`}>{option}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default NumberLineSettings;
